var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvent = function SvgEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#774EE9",
    d: "M9.505 13a1.94 1.94 0 0 1-1.422-.579 1.92 1.92 0 0 1-.583-1.416q0-.838.579-1.422A1.92 1.92 0 0 1 9.495 9q.838 0 1.422.579.583.578.583 1.416t-.579 1.422A1.92 1.92 0 0 1 9.505 13M2 16q-.62 0-1.06-.448A1.45 1.45 0 0 1 .5 14.5v-11q0-.604.44-1.052A1.43 1.43 0 0 1 2 2h1.5V.75q0-.319.214-.534A.72.72 0 0 1 4.246 0q.316 0 .535.216A.72.72 0 0 1 5 .75V2h5V.75q0-.319.214-.534A.72.72 0 0 1 10.746 0q.316 0 .535.216A.72.72 0 0 1 11.5.75V2H13q.619 0 1.06.448.44.449.44 1.052v11q0 .605-.44 1.052A1.43 1.43 0 0 1 13 16zm0-1.5h11V7H2zm0-9h11v-2H2z"
  })));
};
export default SvgEvent;